export default __webpack_public_path__ + "static/media/download_enabled_icon.725242f6.svg";